<template>
    <main-content>
        <kt-panel-body v-if="ip_location !== 'IR'">
            <div class="alert alert-danger" role="alert">
                {{ $t('label.ir_ip_error') }}
            </div>
        </kt-panel-body>
        <div>
            <div class="bg-white p-3">
                <div>
                    <div>
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item">
                                <a
                                    class="nav-link active"
                                    data-toggle="tab"
                                    href="#gateway-info"
                                    role="tab"
                                    aria-selected="false"
                                >
                                    {{ $t("card_to_card.gateway_info") }}
                                </a>
                            </li>
                            <li class="nav-item">
                                <a
                                    class="nav-link"
                                    data-toggle="tab"
                                    href="#gateway-cards"
                                    role="tab"
                                    aria-selected="false"
                                >
                                    {{ $t("card_to_card.gateway_cards") }}
                                </a>
                            </li>
                            <li class="nav-item">
                                <a
                                    class="nav-link"
                                    data-toggle="tab"
                                    href="#settings"
                                    role="tab"
                                    aria-selected="false"
                                >
                                    {{ $t("aside.settings") }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="tab-content">
                    <div class="tab-pane active" id="gateway-info">
                        <update-card-to-card-form v-if="status !== 'loading'"
                                                  :card_to_card="form_data"></update-card-to-card-form>
                    </div>
                    <div class="tab-pane" id="gateway-cards">
                        <gateway-cards v-if="status !== 'loading'"
                                       :card_to_card="form_data"></gateway-cards>
                    </div>
                    <div class="tab-pane" id="settings">
                        <settings v-if="status !== 'loading'&& form_data.bank_cards.length > 0"
                                       :card_to_card="form_data" ></settings>
                    </div>
                </div>
            </div>
        </div>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import UpdateCardToCardForm from './components/update-form'
import GatewayCards from './components/gateway-cards.vue'
import Settings from './components/settings.vue'
import {authService} from '@/common/api.service'
import {mapGetters} from "vuex";

export default {
    components: {
        'main-content': mainContent,
        'gateway-cards': GatewayCards,
        'settings': Settings,
        'update-card-to-card-form': UpdateCardToCardForm
    },
    computed: {
        ...mapGetters('cardToCard', [
            'status', 'form_data'
        ])
    },
    data() {
        return {
            ip_location: '',
            'hashid': this.$route.params.hashid
        }
    },
    mounted() {
        authService.get_ip().then(response => {
            this.ip_location = response.data.countryCode;
        });

    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$store.dispatch('cardToCard/find', vm.hashid)
        })
    },
    methods: {}
}
</script>

<style>

</style>
